import { CommonResponse } from '@gtpl/shared-models/warehouse-management';
import { ApplicationExceptionHandler } from '@gtpl/shared-utils/error-messages';
import { Body, Controller, Post } from '@nestjs/common';
import { ApiTags } from '@nestjs/swagger';
import { CreateNotification } from './dto/create-notification.dto';
import { PlantIdRequest } from './dto/plant-id.request';
import { UpdateNotification } from './dto/update-notification.dto';
import { NotificationsService } from './notifications.service';
@ApiTags('notifications')
@Controller('notifications')
export class NotificationsController {
    constructor(private service: NotificationsService,
        private readonly applicationExceptionHandler: ApplicationExceptionHandler) { }

    /**
     * calling a service to create a new notification
     * @param createNotificationDto 
     * @returns 
     */
    @Post('/createNotification')
    async createNotification(@Body() createNotificationDto: CreateNotification): Promise<CommonResponse>  {
        try {
        return await this.service.createNotification(createNotificationDto);
        } catch (error) {
        return this.applicationExceptionHandler.returnException(CommonResponse, error);
        }
    }

    /**
     * calling a service to update a existing notification
     * @param updateNotificationDto 
     * @returns 
     */
    @Post('/updateNotification')
    async updateNotification(@Body() updateNotificationDto: UpdateNotification): Promise<CommonResponse>  {
        try {
        return await this.service.updateNotification(updateNotificationDto);
        } catch (error) {
        return this.applicationExceptionHandler.returnException(CommonResponse, error);
        }
    }

    /**
     * calling a service to get all notifications
     * @returns 
     */
    @Post('getAllNotifications')
    async getAllNotifications(@Body() req:PlantIdRequest):Promise<CommonResponse> {
        try {
        return await this.service.getAllNotifications(req);
        } catch (error) {
        return this.applicationExceptionHandler.returnException(CommonResponse, error);
        }
    }
    
    /**
    * calling a service to notifications by plant id which are not completed
    * @param plantIdReq
    * @returns 
    */
    @Post('getOpenNotificationsByPlantId')
    async getOpenNotificationsByPlantId(@Body() plantIdReq: PlantIdRequest):Promise<CommonResponse> {
        try {
            return await this.service.getOpenNotificationsByPlantId(plantIdReq);
        } catch (error) {
            return this.applicationExceptionHandler.returnException(CommonResponse, error);
        }
    }
}
